(function () {
    // Early exit if Bootstrap JS is already running elsewhere on the page
    if (window.bootstrap) return;
    function scrollIfNeeded(element) {
        // 1. Create a one-time observer to check visibility
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                // 2. If entry.isIntersecting is false, the element is NOT in view
                if (!entry.isIntersecting) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
            });

            // 3. Disconnect immediately so it doesn't keep tracking
            observer.disconnect();
        }, {
            threshold: 0.5 // Triggers if less than 50% of the element is visible
        });

        // 4. Start the check
        observer.observe(element);
    }

    /* ==========================================================================
       Tab Module
       ========================================================================== */
    const handleTabClick = (tabTrigger) => {
        const parent = tabTrigger.parentElement;
        const isSelected = tabTrigger.getAttribute("aria-selected") === "true";

        if (isSelected || !parent) return;

        // Deactivate sibling tabs
        Array.from(parent.children).forEach(child => {
            child.setAttribute("aria-selected", "false");
            child.classList.remove("active");
        });

        // Activate clicked tab
        tabTrigger.setAttribute("aria-selected", "true");
        tabTrigger.classList.add("active");

        // Toggle corresponding content panel
        const targetSelector = tabTrigger.dataset.bsTarget;
        const target = targetSelector ? document.querySelector(targetSelector) : null;

        if (target) {
            const tabContent = target.closest(".tab-content");
            if (tabContent) {
                Array.from(tabContent.children).forEach(child => {
                    child.classList.remove("active", "show");
                });
            }
            target.classList.add("active", "show");
        }
    };

    /* ==========================================================================
       Collapse Helpers
       ========================================================================== */
    const getTargets = (element) => {
        const targetSelector = element.dataset.bsTarget;
        const secondarySelector = element.dataset.target2;

        return {
            targetEl: targetSelector ? document.querySelector(targetSelector) : null,
            targetEl2: secondarySelector ? document.querySelector(secondarySelector) : null
        };
    };

    const showCollapse = (element) => {
        const { targetEl, targetEl2 } = getTargets(element);

        if (targetEl) {
            targetEl.classList.add("show");
            element.setAttribute("aria-expanded", "true");
            element.classList.remove("collapsed");

            if (targetEl2) {
                targetEl2.classList.add("expanded");
            }

            targetEl.dispatchEvent(new CustomEvent("show.bs.collapse", { bubbles: true, cancelable: true }));
        }
    };

    const hideCollapse = (element) => {
        const { targetEl, targetEl2 } = getTargets(element);

        if (targetEl) {
            targetEl.classList.remove("show");
            element.setAttribute("aria-expanded", "false");
            element.classList.add("collapsed");

            if (targetEl2) {
                targetEl2.classList.remove("expanded");
            }

            targetEl.dispatchEvent(new CustomEvent("hide.bs.collapse", { bubbles: true, cancelable: true }));
        }
    };

    /* ==========================================================================
       Event Listeners
       ========================================================================== */
    // Unified delegated click listener
    document.addEventListener("click", (event) => {
        // Tab handler
        const tabTrigger = event.target.closest('[data-bs-toggle="tab"]');
        if (tabTrigger) {
            handleTabClick(tabTrigger);
            return;
        }

        // Collapse handler
        const collapseBtn = event.target.closest('[data-bs-toggle="collapse"]');
        if (collapseBtn) {

            event.preventDefault();

            if (collapseBtn.parentElement.classList.contains("acpanel")) {
                history.pushState(null, null, collapseBtn.dataset.bsTarget)
            }

            const isExpanded = collapseBtn.getAttribute("aria-expanded") === "true";
            const targetSelector = collapseBtn.dataset.bsTarget;
            const target = targetSelector ? document.querySelector(targetSelector) : null;

            closeOpenCollapsers(collapseBtn)

            if (targetSelector) {
                const relatedBtns = document.querySelectorAll(`[data-bs-toggle="collapse"][data-bs-target="${targetSelector}"]`);
                relatedBtns.forEach(btn => {
                    if (!isExpanded) {
                        showCollapse(btn);
                    } else {
                        hideCollapse(btn);
                    }
                });
                if (target) {
                    scrollIfNeeded(collapseBtn)
                }
            }
        }
    });

    // Close only currently OPEN collapses on Escape key
    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            closeOpenCollapsers()
        }
    });

    const isAncestor = (parent, child) => parent.contains(child) && parent !== child;

    function closeOpenCollapsers(collapseBtn) {
        // close only if the thing currently opened is not a ancestor of the button just pressed  
        // and only if in the main section
        const openCollapses = document.querySelectorAll('[data-bs-toggle="collapse"][aria-expanded="true"]');
        openCollapses.forEach((e) => {
            // e is the button that is open
            const main = e.closest("main")
            if (main) {
                const targetSelector = e.dataset.bsTarget;
                const target = targetSelector ? document.querySelector(targetSelector) : null;

                // Don't hide if the currently opened area is the one in which a button click happened
                let doAction = !target || !isAncestor(target, collapseBtn)
                if (doAction) {
                    hideCollapse(e)
                }
            }
        });

    }
})();